export function handleLogIn() {
  const searchParams = new URLSearchParams(window.location.search)
  searchParams.append('fakeAuth', '')

  const url = (window.location.href.split('?')[0] + '?' + searchParams.toString()).replace(/=$|=(?=&)/g, '')
  // eslint-disable-next-line
  window.location.href = url
}

export function handleLogOut() {
  const searchParams = new URLSearchParams(window.location.search)
  searchParams.delete('fakeAuth')

  const url = (window.location.href.split('?')[0] + '?' + searchParams.toString()).replace(/=$|=(?=&)/g, '')
  // eslint-disable-next-line
  window.location.href = url
}